import React, {Component} from 'react';
import {Alert} from 'reactstrap';
import autobind from 'autobind-decorator';

export default class UpdateSuccess extends Component {
    state = {
        isOpen: true,
        timeOut: setTimeout(this.onDismiss, 5000)
    }

    @autobind
    onDismiss() {
        this.setState({isOpen: false})
    }

    render() {
        const {isOpen} = this.state;
        const {message} = this.props;
        return <Alert color={message.color} isOpen={isOpen} toggle={this.onDismiss}>
            {message.text}
        </Alert>
    }
}
